import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-pray"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M13.6221 2.30305C14.4137 2.28757 15.1051 2.83572 15.2705 3.60999L17.4893 13.9953L19.2041 15.7102L15.0886 19.8257L12.8543 17.5914C12.3124 17.0495 12.0064 16.3159 12.0021 15.55H11.996C11.9917 16.3159 11.6856 17.0495 11.1438 17.5914L8.90947 19.8257L4.79395 15.7102L6.50874 13.9953L8.72754 3.60999C8.89296 2.83573 9.5843 2.28758 10.3759 2.30305C11.274 2.32062 11.9933 3.05236 11.996 3.95003H12.002C12.0048 3.05236 12.724 2.32064 13.6221 2.30305Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M19.2039 15.71L15.0884 19.8255L17.1461 21.8832L21.2616 17.7677L19.2039 15.71Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M4.79408 15.71L8.90959 19.8255L6.85184 21.8832L2.73633 17.7677L4.79408 15.71Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.2041 15.7102L17.4893 13.9954L15.2705 3.60999C15.1051 2.83572 14.4137 2.28757 13.6221 2.30305C12.7223 2.32066 12.002 3.05519 12.002 3.95525L12.002 15.5336C12.002 16.3054 12.3086 17.0456 12.8543 17.5914L15.0886 19.8257M19.2041 15.7102L15.0886 19.8257M19.2041 15.7102L21.2619 17.7679L17.1463 21.8834L15.0886 19.8257M4.79408 15.7102L6.50888 13.9954L8.72767 3.60999C8.89309 2.83572 9.58444 2.28757 10.376 2.30305C11.2759 2.32066 11.9962 3.05519 11.9962 3.95525L11.9962 15.5336C11.9962 16.3054 11.6896 17.0456 11.1439 17.5914L8.90959 19.8257M4.79408 15.7102L8.90959 19.8257M4.79408 15.7102L2.73633 17.7679L6.85184 21.8834L8.90959 19.8257","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GesturePray = Vue.extend<IconProps>({
  name: 'GesturePrayIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-pray',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GesturePray;
